<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <router-link :to ="{name: 'Index'}">Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'na',
  data () {
    return {
      msg: '!THIS SITE IS UNDER CONSTRUCTION!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  display: block;
  text-align: center;
}
h1, h2 {
  font-weight: normal;
  margin: auto;
  color: black;
  padding: 20px;
  margin: 20px;
  border: none;
}
a {
  position: relative;

  color: red;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/na.vue